export default {
  SET_CAMPAIGN(state, campaign) {
    state.campaign = campaign;
  },

  SET_HAS_EXPIRATION(state, hasExpiration) {
    state.hasExpiration = hasExpiration;
  },

  SET_VALID_FROM(state, valid_from) {
    state.valid_from = valid_from;
  },

  SET_VALID_UNTIL(state, valid_until) {
    state.valid_until = valid_until;
  },

  SET_VALIDATE(state, validate) {
    state.validate = validate;
  },

  SET_PROMOTIONS_CAMPAIGNS(state, promotionsCampaigns) {
    state.promotionsCampaigns = promotionsCampaigns;
  },

  SET_REGIONS_SELECTED(state, regionsSelected) {
    state.regionsSelected = regionsSelected;
  },

  SET_ALL_PLACES_SELECTED(state, allPlacesSelected) {
    state.allPlacesSelected = allPlacesSelected;
  },

  SET_CHILD_SELECTED(state, childSelected) {
    state.childSelected = childSelected;
  },

  SET_POSTERS_SELECTED(state, postersSelected) {
    state.postersSelected = postersSelected;
  },

  SET_POSTER_ID(state, posterId) {
    state.posterId = posterId;
  },

  SET_STATES_SELECTED(state, statesSelected) {
    state.statesSelected = statesSelected;
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/store/release-posters/mutations.js